module.exports = __webpack_public_path__ + "img/x-gray.b61dc6c1.svg";